import React from 'react';
import { t } from '../../utilities/translator';

const Stars = ({ value }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (i <= value)
      stars.push(
        <div className="star" key={i}>
          <i className="star-item  ri-star-fill" />
        </div>
      );
  }

  return (
    <>
      <span className="stars-wrap">{stars}</span>
      <span>
        {value} {t('secondaryFilter.stars_plural', { count: value })}
      </span>
    </>
  );
};

export default Stars;
